const STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'AS',
  'FM',
  'GU',
  'MH',
  'MP',
  'PW',
  'PR',
  'UM',
  'VI'
];

export const MEXICAN_STATES = [
  'AG',
  'BC',
  'BS',
  'CM',
  'CS',
  'CH',
  'CD',
  'CO',
  'CL',
  'DG',
  'EM',
  'GT',
  'GR',
  'HG',
  'JA',
  'MI',
  'MO',
  'NA',
  'NL',
  'OA',
  'PU',
  'QT',
  'QR',
  'SL',
  'SI',
  'SO',
  'TB',
  'TM',
  'TL',
  'VE',
  'YU',
  'ZA'
];

export default STATE_CODES;
